import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseCompanyMovementsTotalizerProps<T> = {
  filters: {
    id: string;
    branchId?: string;
    establishmentBranchId?: string;
    fromInternalBase?: string;
    startDate?: string;
    endDate?: string;
  },
  mapper?: (data: any) => T;
};
const useCompanyMovementsTotalizer = <T,>({
  filters: { id, branchId, fromInternalBase = 'false',
    establishmentBranchId, startDate, endDate },
  mapper = Mapper.default<T>() }:
  UseCompanyMovementsTotalizerProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['companyMovementsTotalizer', id, branchId, establishmentBranchId, fromInternalBase, startDate, endDate],
    queryFn: () => {
      return privateAxios.get(`/client/companies/${id}/movements_totalizer`, {
        params: {
          "q[branch_id_eq]": branchId,
          "q[created_at_gteq]": startDate,
          "q[created_at_lteq]": endDate,
          'q[establishment_branch_id_eq]': establishmentBranchId,
          'q[from_internal_base_eq]': fromInternalBase,
        },
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, isPending, ...rest };
};

export default useCompanyMovementsTotalizer;
